export default {
      id: "participantSK-usage",
      viewBox: "0 0 54 40",
      url: "assets/" + "sprite.svg#participantSK-usage",
      toString: function () {
        return this.url;
      }
    }